import React from 'react'
import { FaLinkedin } from "react-icons/fa";
import { FaGithub } from "react-icons/fa";
import { SiCodeforces } from "react-icons/si";  
import { FaInstagram } from "react-icons/fa";
import './socials.css'

const Socials = () => {
    return (
        <div className="socials" style={{display:'flex', gap:'1.2rem', alignItems:'center'}}>
            <a href="https://www.linkedin.com/in/pulkit-agrawal-a5295427a/" target="_blank">
                <FaLinkedin size={24} />
            </a>
            <a href="https://www.github.com/errorassassin/" target="_blank">
                <FaGithub size={24} />
            </a>
            <a href="https://codeforces.com/profile/ErrorAssassin/" target="_blank">
                <SiCodeforces size={24} />
            </a>
            <a href="https://www.instagram.com/05_pulkitt" target="_blank">
                <FaInstagram size={24} />
            </a>
        </div>
    )
}

export default Socials